import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import { SearchLg, TextInput } from "@opendate-app/setlist";
import useLocalSearchShortcut from "../../shared/hooks/useLocalSearchShortcut";

const SearchBar = ({ onDebouncedChange, placeholder = "Search", debounceMs = 500, defaultValue = "" }) => {
  const [searchTerm, setSearchTerm] = useState(defaultValue);
  const debouncedFnRef = useRef(null);
  const callbackRef = useRef(onDebouncedChange);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const shortcut = useLocalSearchShortcut(inputRef);

  useEffect(() => {
    callbackRef.current = onDebouncedChange;
  }, [onDebouncedChange]);

  useEffect(() => {
    debouncedFnRef.current = _.debounce((value) => {
      callbackRef.current(value);
    }, debounceMs);

    return () => {
      if (debouncedFnRef.current) {
        debouncedFnRef.current.cancel();
      }
    };
  }, [debounceMs]);

  useEffect(() => {
    inputRef.current = wrapperRef.current?.querySelector("input") || null;
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (debouncedFnRef.current) {
      debouncedFnRef.current(value);
    }
  };

  return (
    <div ref={wrapperRef} style={{ width: 296, maxWidth: "100%" }}>
      <TextInput
        leadingIcon={SearchLg}
        trailingText={shortcut}
        placeholder={placeholder}
        aria-label={placeholder}
        value={searchTerm}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchBar;
